<div id="detailList" [ngClass]="{ 'accessibility-theme': isColorsEnabled }" class="ya-typography">
  <ya-subheader [hasContent]="false" [disableNavigateBack]="true" (onNavigateBackClick)="navigateBack()"></ya-subheader>
  <div class="ya-page-content ya-page-content--webshop">
    <ng-container *ngIf="hasData; then productDetailView else emptyTemplate"></ng-container>
    <ng-template #productDetailView>
      <ng-container *ngIf="isSmallView; then mobileProductHeader else desktopProductHeader"></ng-container>
      <ng-template #mobileProductHeader>
        <ng-container *ngIf="hasImage; then Image else NoImage"></ng-container>
        <ng-template #Image>
          <div class="product-image-wrapper product-content__image" (swiperight)="SwiperNavigateBack()">
            <div class="aspect-ratio-box">
              <div class="aspect-ratio-box-inside">
                <div class="aspect-ration-img-box">
                  <img class="ya_image" [src]="productDetailViewModel.imagePhoto" (error)="onImageError($event)" />
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template #NoImage>
          <div class="noimage-fake-subheader"></div>
        </ng-template>
      </ng-template>
      <ng-template #desktopProductHeader>
        <div class="product-content__top">
          <div class="product-image-wrapper product-content__image" (swiperight)="SwiperNavigateBack()">
            <div class="aspect-ratio-box">
              <div class="aspect-ratio-box-inside">
                <div class="aspect-ration-img-box">
                  <ng-container *ngIf="hasImage;then imageTopTemplate else noImageTopTemplate"></ng-container>
                  <ng-template #imageTopTemplate>
                    <img class="ya_image" [src]="productDetailViewModel.imagePhoto" (error)="onImageError($event)" />
                  </ng-template>
                  <ng-template #noImageTopTemplate>
                    <div class="noimage-fake-subheader">
                      <div class="title ya-detail-page-header product__title">
                        <h2>{{productDetailViewModel?.label}}</h2>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
          <div class="product-base-content">
            <div class="product-content__header">
              <div class="title ya-detail-page-header product__title">
                <h2>{{productDetailViewModel?.label}}</h2>
              </div>
              <div *ngIf="!isEMenu && !isWebvoucher()" class="like">
                <ya-favoritebutton [contentType]="contentType.sub_Product" class="favoritebutton"
                  [likeStatus]="productDetailViewModel.like" [modelId]="productDetailViewModel.productId">
                </ya-favoritebutton>
              </div>
            </div>
            <div class="product-content__desc product-content">
              <ng-container *ngIf="hasDescriprion">
                <div innerHtml="{{productDetailViewModel.description}}"></div>
              </ng-container>
            </div>
            <div class="product-content__rating">
              <div *ngIf="!isEMenu && serviceId !== WebShopMode.Webvoucher"
                class="ya-ranking-bar ya-ranking-bar--webshop">
                <bar-rating [rate]="productDetailViewModel.rate" [max]="5" [readOnly]="true"
                  [theme]="'fontawesome-o'"></bar-rating>
                <div class="rate-click-div" (click)="openRateModel(productDetailViewModel)"></div>
              </div>
            </div>
            <ng-container
              *ngIf="isItemTagEnabled && productDetailViewModel.itemTags && productDetailViewModel.itemTags.length > 0">
              <div class="product-content__tags item-tag-container">
                <ng-container *ngIf="itemTagType === tagType.Icon; then iconTagTemplate else textTagTemplate">
                </ng-container>
                <ng-template #iconTagTemplate>
                  <ng-container *ngFor="let itemTag of productDetailViewModel.itemTags">
                    <div class="tag-icon-container">
                      <ng-container *ngIf="itemTag.svgIcon">
                        <div class="inline-icon" [innerHTML]="svgSanitizer(itemTag.svgIcon, itemTag.color)">
                        </div>
                      </ng-container>
                      <span>{{itemTag.label}}</span>
                    </div>
                  </ng-container>
                </ng-template>
                <ng-template #textTagTemplate>
                  <ng-container *ngFor="let itemTag of productDetailViewModel.itemTags">
                    <span class="label-tag">{{itemTag.label}}</span>
                  </ng-container>
                </ng-template>
              </div>
            </ng-container>
            <ng-container *ngIf="productDetailViewModel.use_eCommerce ||hasDepositPrice()">
              <div class="product-content__info">
                <ng-container *ngIf="hasDepositPrice()">
                  <span>{{depositInfo()}}</span>
                </ng-container>
                <div class="ecommerce-info">
                  <div *ngIf="productDetailViewModel.use_eCommerce">
                    <ng-container
                      *ngIf="productDetailViewModel.hasCaffeineLevel || productDetailViewModel.hasAlcoholLevel">
                      <div class="content-detail">
                        <span class="content-Detail-label"
                          *ngIf="productDetailViewModel.hasCaffeineLevel">{{CaffeinelevelText}}</span>
                        <span *ngIf="productDetailViewModel.hasAlcoholLevel">{{AlcohollevelText}}</span>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="hasBaseUnit">
                      <div class="base-content-info">
                        <span>{{baseUnit}}</span>
                      </div>
                    </ng-container>
                    <div *ngIf="productDetailViewModel.prepackaged">
                      <span langkey="phProductDetail_prepackaged"></span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-template>
      <mat-tab-group mat-stretch-tabs [(selectedIndex)]="currentProductSettingIndex" (swipeleft)="swipeLeftHandler()"
        (swiperight)="swipeRightHandler()" animationDuration="20ms" class="ya-tab-group"
        [class.webvoucher]="isWebvoucher()">
        <ng-container
          *ngFor="let productHeaderGroup of productDetailViewModel.productHeaderGroups; let groupIndex = index">
          <ng-container *ngIf="ValidateTabs(productHeaderGroup.id,groupIndex)">
            <mat-tab [label]="setpageTabLabel(productHeaderGroup.id)">
              <div class="ya-tab-content-wrapper ya-tab-content-wrapper--padding">
                <ng-container [ngSwitch]="true">
                  <!-- Overview Tab -->
                  <ng-container *ngSwitchCase="productHeaderGroup.id === 1">
                    <div class="overview">
                      <ng-container *ngIf="isSmallView">
                        <div class="col">
                          <div class="header">
                            <div class="title ya-detail-page-header">
                              <h2>{{productDetailViewModel?.label}}</h2>
                            </div>
                            <div *ngIf="!isEMenu && !isWebvoucher()" class="like">
                              <ya-favoritebutton [contentType]="contentType.sub_Product" class="favoritebutton"
                                [likeStatus]="productDetailViewModel.like" [modelId]="productDetailViewModel.productId">
                              </ya-favoritebutton>
                            </div>
                          </div>
                          <ng-container *ngIf="productHeaderGroup.content">
                            <div class="product-content" innerHtml="{{productHeaderGroup.content}}"></div>
                          </ng-container>
                          <ng-container
                            *ngIf="isItemTagEnabled && productDetailViewModel.itemTags && productDetailViewModel.itemTags.length > 0">
                            <div class="item-tag-container">
                              <ng-container
                                *ngIf="itemTagType === tagType.Icon; then iconTagTemplate else textTagTemplate">
                              </ng-container>
                              <ng-template #iconTagTemplate>
                                <ng-container *ngFor="let itemTag of productDetailViewModel.itemTags">
                                  <div class="tag-icon-container">
                                    <ng-container *ngIf="itemTag.svgIcon">
                                      <div class="inline-icon"
                                        [innerHTML]="svgSanitizer(itemTag.svgIcon, itemTag.color)">
                                      </div>
                                    </ng-container>
                                    <span>{{itemTag.label}}</span>
                                  </div>
                                </ng-container>
                              </ng-template>
                              <ng-template #textTagTemplate>
                                <ng-container *ngFor="let itemTag of productDetailViewModel.itemTags">
                                  <span class="label-tag">{{itemTag.label}}</span>
                                </ng-container>
                              </ng-template>
                            </div>
                          </ng-container>
                          <div class="actions">
                            <div *ngIf="!isEMenu && serviceId !== WebShopMode.Webvoucher"
                              class="ya-ranking-bar ya-ranking-bar--webshop">
                              <bar-rating [rate]="productDetailViewModel.rate" [max]="5" [readOnly]="true"
                                [theme]="'fontawesome-o'"></bar-rating>
                              <div class="rate-click-div" (click)="openRateModel(productDetailViewModel)"></div>
                            </div>
                          </div>
                          <div *ngIf="productDetailViewModel.use_eCommerce" class="content-info">
                            <ng-container
                              *ngIf="productDetailViewModel.hasCaffeineLevel || productDetailViewModel.hasAlcoholLevel">
                              <div class="content-level-info">
                                <!-- Alcohol & caffeine-->
                                <span *ngIf="productDetailViewModel.hasCaffeineLevel">{{CaffeinelevelText}}</span>
                                <span *ngIf="productDetailViewModel.hasAlcoholLevel">{{AlcohollevelText}}</span>
                              </div>
                            </ng-container>
                            <ng-container *ngIf="hasBaseUnit">
                              <div class="base-content-info">
                                <span>{{baseUnit}}</span>
                              </div>
                            </ng-container>
                            <div *ngIf="productDetailViewModel.prepackaged">
                              <span langkey="phProductDetail_prepackaged"></span>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <div class="col second">
                        <div class="choice-extra-container">
                          <ng-container *ngFor="let extragroup of visibleExtragroups; let extraIndex = index">
                            <div class="product-choice-extra">
                              <div class="title ya-header-2">
                                <span *ngIf="extragroup.label != null">{{extragroup.label}}</span>
                                <span *ngIf="extragroup.label == null"><span
                                    langkey="phMenuDetail_ExtragroupTitle"></span>
                                  {{extraIndex + 1}}</span>
                                <ng-container *ngIf="extragroup.min > 0">
                                  <span class="amountOf rightside"><span langkey="phMenuDetail_Required"></span>
                                    {{'('+ extragroup.count}}/{{extragroup.min + ')'}}</span>
                                </ng-container>
                                <ng-container *ngIf="extragroup.max > 1 && extragroup.min <= 0">
                                  <span class="amountOf rightside">({{extragroup.count}}/{{extragroup.max}})</span>
                                </ng-container>
                              </div>
                              <div class="item-list">
                                <ng-container *ngFor="let extraItem of extragroup.items; let i = index">
                                  <ng-container
                                    *ngIf="i < extragroup.showUpToNItems || extragroup.showUpToNItems < 0 || extragroup.min > 0">
                                    <ng-container
                                      *ngIf="isSmallView; then mobileExtraView else desktopExtraView"></ng-container>
                                    <ng-template #mobileExtraView>
                                      <ng-container
                                        *ngIf="extraItem.subExtras.length > 1; then extraItemWithSubChoices else simpleExtraItem">
                                      </ng-container>
                                      <ng-template #simpleExtraItem>
                                        <div class="item-small item-small-custom"
                                          (click)="onItemClick(extragroup, extraItem); $event.stopPropagation()"
                                          [ngClass]="extraItem.count > 0 ? 'selected' : ''"
                                          [class.not-available]="!extraItem.isAvailable">
                                          <div class="not-available-overlay" *ngIf="!extraItem.isAvailable">
                                            <div class="not-available-header">[<span
                                                langkey="phProductDetail_CurrentlyNotAvailable"></span>]
                                            </div>
                                          </div>
                                          <div class="info-small" [class.active]="extraItem.count > 0">
                                            <div class="label-small">
                                              <div class="warning-small">
                                                <div class="inline-icon item-warning-svg"
                                                  inlineSVG="shop-icons.svg#ya-hypersoft-achtung"></div>
                                              </div>
                                              <div class="check-wrap-small" [class.active]="extraItem.count > 0">
                                                <div class="check-small" [class.active]="extraItem.count > 0">
                                                  <div *ngIf="extraItem.count > 0" class="inline-icon item-check-svg"
                                                    inlineSVG="shop-icons.svg#ya-done">
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="extra-content">
                                                <div class="text-small">{{extraItem.label}}</div>
                                                <!--Extra: Base price & Deposit-->
                                                <ng-container
                                                  *ngIf="(extraItem.displayExtraBasePrice$|async) ||extraItem.deposit>0">
                                                  <div class="product-content__info">
                                                    <ng-container *ngIf="extraItem.deposit>0">
                                                      <span
                                                        class="extra-info">{{extraitemDepositInfo(extraItem)}}</span>
                                                    </ng-container>
                                                    <ng-container *ngIf="(extraItem.displayExtraBasePrice$|async)">
                                                      <ng-container *ngIf="showBasePrice(extraItem)">
                                                        <div class="ecommerce-info">
                                                          <div class="base-content-info">
                                                            <span
                                                              class="extra-info">{{getExtraItemBaseUnit(extraItem)}}</span>
                                                          </div>
                                                        </div>
                                                      </ng-container>
                                                    </ng-container>
                                                  </div>
                                                </ng-container>
                                              </div>
                                            </div>
                                            <ng-container
                                              *ngIf="extragroup.max > 1 && extraItem.max > 1 && extraItem.count > 0">
                                              <div class="amountChanger-small">
                                                <div class="minus"
                                                  (click)="decrementExtra(extragroup, extraItem); $event.stopPropagation()">
                                                  <div class="inline-icon"
                                                    inlineSVG="shop-icons.svg#ya-hypersoft-minus-voll">
                                                  </div>
                                                </div>
                                                <div class="amount">{{extraItem.count}}</div>
                                                <div class="plus"
                                                  (click)="incrementExtra(extragroup, extraItem); $event.stopPropagation()">
                                                  <div class="inline-icon"
                                                    inlineSVG="shop-icons.svg#ya-hypersoft-plus-voll">
                                                  </div>
                                                </div>
                                              </div>
                                            </ng-container>
                                            <div class="price-small">{{priceFormatter(extraItem.price)}}</div>
                                            <div class="additional-content"
                                              *ngIf="extraItem.hasAdditionalInfo$ | async">
                                              <div a11y_Button class="additional-info"
                                                (click)="openAddidtionInformationDialog(extraItem);$event.stopPropagation()">
                                                <span>i</span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </ng-template>
                                      <ng-template #extraItemWithSubChoices>
                                        <mat-expansion-panel class="subchoice" (opened)="extraItem.expanded=true"
                                          (closed)="extraItem.expanded=false" hideToggle="true"
                                          [disabled]="!extraItem.isAvailable">
                                          <mat-expansion-panel-header collapsedHeight="*" expandedHeight="*">
                                            <mat-panel-title>
                                              <div class="extraitem-content"
                                                [class.not-available]="!extraItem.isAvailable">
                                                <div class="not-available-overlay" *ngIf="!extraItem.isAvailable">
                                                  <div class="not-available-header">[<span
                                                      langkey="phProductDetail_CurrentlyNotAvailable"></span>]
                                                  </div>
                                                </div>
                                                <div [class.expanded]="extraItem.expanded"
                                                  class="inline-icon subItemExpand-icon"
                                                  inlineSVG="shop-icons.svg#ya-expand_more">
                                                </div>
                                                <div class="item-small subitem_header"
                                                  [ngClass]="extraItem.count > 0 ? 'selected' : ''">
                                                  <div class="info-small">
                                                    <div class="label-small">
                                                      <div class="extra-content">
                                                        <div class="text-small text">{{extraItem.label}}</div>
                                                        <!--Extra: Base price & Deposit-->
                                                        <ng-container
                                                          *ngIf="(extraItem.displayExtraBasePrice$|async) ||extraItem.deposit>0">
                                                          <div class="product-content__info">
                                                            <ng-container *ngIf="extraItem.deposit>0">
                                                              <span
                                                                class="extra-info">{{extraitemDepositInfo(extraItem)}}</span>
                                                            </ng-container>
                                                            <ng-container
                                                              *ngIf="(extraItem.displayExtraBasePrice$|async)">
                                                              <ng-container *ngIf="showBasePrice(extraItem)">
                                                                <div class="ecommerce-info">
                                                                  <div class="base-content-info">
                                                                    <span
                                                                      class="extra-info">{{getExtraItemBaseUnit(extraItem)}}</span>
                                                                  </div>
                                                                </div>
                                                              </ng-container>
                                                            </ng-container>
                                                          </div>
                                                        </ng-container>
                                                      </div>
                                                    </div>
                                                    <ng-container
                                                      *ngIf="extragroup.max > 1 && extraItem.max > 1 && extraItem.count > 0">
                                                      <div class="amount">{{extraItem.count}}</div>
                                                    </ng-container>
                                                    <div class="price-small" *ngIf="extraItem.price > 0">
                                                      {{priceFormatter(extraItem.price)}}</div>
                                                  </div>
                                                </div>
                                                <div class="additional-content"
                                                  *ngIf="extraItem.hasAdditionalInfo$ | async">
                                                  <div a11y_Button class="additional-info"
                                                    (click)="openAddidtionInformationDialog(extraItem);$event.stopPropagation()">
                                                    <span>i</span>
                                                  </div>
                                                </div>
                                              </div>
                                            </mat-panel-title>
                                          </mat-expansion-panel-header>
                                          <div class="subItems">
                                            <ng-container *ngFor="let subextraItem of extraItem.subExtras">
                                              <div class="extraitem-content">
                                                <div a11y_Button class="item-small subitem"
                                                  (click)="onItemClick(extragroup, extraItem, subextraItem); $event.stopPropagation()"
                                                  [ngClass]="subextraItem.count > 0 ? 'selected' : ''"
                                                  [class.not-available]="!subextraItem.isAvailable">
                                                  <div class="not-available-overlay" *ngIf=" !subextraItem.isAvailable">
                                                    <div class="not-available-header">[<span
                                                        langkey="phProductDetail_CurrentlyNotAvailable"></span>]
                                                    </div>
                                                  </div>
                                                  <div class="info-small">
                                                    <div class="label-small">
                                                      <div class="check-wrap-small"
                                                        [class.active]="subextraItem.count > 0">
                                                        <div class="check-small"
                                                          [class.active]="subextraItem.count > 0">
                                                          <div *ngIf="subextraItem.count > 0"
                                                            class="inline-icon item-check-svg"
                                                            inlineSVG="shop-icons.svg#ya-done">
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div class="extra-content">
                                                        <div class="extra-info">{{subextraItem.label}}</div>
                                                        <!--Subextra: Base price & Deposit-->
                                                        <ng-container
                                                          *ngIf="(subextraItem.displayExtraBasePrice$|async) ||subextraItem.deposit>0">
                                                          <div class="product-content__info">
                                                            <ng-container *ngIf="subextraItem.deposit>0">
                                                              <span
                                                                class="extra-info">{{extraitemDepositInfo(subextraItem)}}</span>
                                                            </ng-container>
                                                            <ng-container
                                                              *ngIf="(subextraItem.displayExtraBasePrice$|async)">
                                                              <ng-container *ngIf="showBasePrice(subextraItem)">
                                                                <div class="ecommerce-info">
                                                                  <div class="base-content-info">
                                                                    <span
                                                                      class="extra-info">{{getExtraItemBaseUnit(subextraItem)}}</span>
                                                                  </div>
                                                                </div>
                                                              </ng-container>
                                                            </ng-container>
                                                          </div>
                                                        </ng-container>
                                                      </div>
                                                    </div>
                                                    <ng-container
                                                      *ngIf="extragroup.max > 1 && subextraItem.max > 1 && subextraItem.count > 0">
                                                      <div class="amountChanger-small">
                                                        <div class="minus"
                                                          (click)="decrementExtra(extragroup, extraItem, subextraItem); $event.stopPropagation()">
                                                          <div class="inline-icon"
                                                            inlineSVG="shop-icons.svg#ya-hypersoft-minus-voll">
                                                          </div>
                                                        </div>
                                                        <div class="amount">{{subextraItem.count}}</div>
                                                        <div class="plus"
                                                          (click)="incrementExtra(extragroup, extraItem, subextraItem); $event.stopPropagation()">
                                                          <div class="inline-icon"
                                                            inlineSVG="shop-icons.svg#ya-hypersoft-plus-voll">
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </ng-container>
                                                    <div class="price-small">{{priceFormatter(subextraItem.price)}}
                                                    </div>
                                                  </div>
                                                  <div class="additional-content"
                                                    *ngIf="subextraItem.hasAdditionalInfo$ | async">
                                                    <div a11y_Button class="additional-info"
                                                      (click)="openAddidtionInformationDialog(subextraItem);$event.stopPropagation()">
                                                      <span>i</span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </ng-container>
                                          </div>
                                        </mat-expansion-panel>
                                      </ng-template>
                                    </ng-template>
                                    <ng-template #desktopExtraView>
                                      <ng-container
                                        *ngIf="extraItem.subExtras.length > 1; then extraWithSubExtras else extraWithoutSubExtras">
                                      </ng-container>
                                      <ng-template #extraWithoutSubExtras>
                                        <div class="extraitem-content">
                                          <div class="item" [class.not-available]="!extraItem.isAvailable">
                                            <div class="not-available-overlay" *ngIf="!extraItem.isAvailable">
                                              <div class="not-available-header">[<span
                                                  langkey="phProductDetail_CurrentlyNotAvailable"></span>]
                                              </div>
                                            </div>
                                            <div class="info" [class.active]="extraItem.count > 0">
                                              <ng-container
                                                *ngIf="extraItem.hasImage;then extraItemWithImage else extraItemWithoutImage"></ng-container>
                                              <ng-template #extraItemWithImage>
                                                <div class="extra-with-image">
                                                  <div a11y_Button class="item"
                                                    (click)="onItemClick(extragroup, extraItem); $event.stopPropagation()"
                                                    [ngClass]="extraItem.count > 0 ? 'selected' : ''">
                                                    <div class="article-image-container">
                                                      <img class="ya_image article-image" [src]="extraItem.imageUrl" />
                                                    </div>
                                                    <div class="article-item">
                                                      <div class="article-texte">
                                                        <div class="extra-content">
                                                          <div class="article-label">
                                                            <div class="text">{{extraItem.label}}</div>
                                                          </div>
                                                          <!--Extra: Base price & Deposit-->
                                                          <ng-container
                                                            *ngIf="(extraItem.displayExtraBasePrice$|async) ||extraItem.deposit>0">
                                                            <div class="product-content__info">
                                                              <ng-container *ngIf="extraItem.deposit>0">
                                                                <span
                                                                  class="extra-info">{{extraitemDepositInfo(extraItem)}}</span>
                                                              </ng-container>
                                                              <ng-container
                                                                *ngIf="(extraItem.displayExtraBasePrice$|async)">
                                                                <ng-container *ngIf="showBasePrice(extraItem)">
                                                                  <div class="ecommerce-info">
                                                                    <div class="base-content-info">
                                                                      <span
                                                                        class="extra-info">{{getExtraItemBaseUnit(extraItem)}}</span>
                                                                    </div>
                                                                  </div>
                                                                </ng-container>
                                                              </ng-container>
                                                            </div>
                                                          </ng-container>
                                                        </div>
                                                        <div class="extra-amount">
                                                          <div class="price">{{priceFormatter(extraItem.price)}}</div>
                                                          <ng-container
                                                            *ngIf="extragroup.max > 1 && extraItem.max > 1 && extraItem.count > 0">
                                                            <div class="amountChanger">
                                                              <div class="minus"
                                                                (click)="decrementExtra(extragroup, extraItem); $event.stopPropagation()">
                                                                <div class="inline-icon"
                                                                  inlineSVG="shop-icons.svg#ya-hypersoft-minus-voll">
                                                                </div>
                                                              </div>
                                                              <div class="amount">{{extraItem.count}}</div>
                                                              <div class="plus"
                                                                (click)="incrementExtra(extragroup, extraItem); $event.stopPropagation()">
                                                                <div class="inline-icon"
                                                                  inlineSVG="shop-icons.svg#ya-hypersoft-plus-voll">
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </ng-container>
                                                        </div>
                                                      </div>
                                                      <div class="article-icons">
                                                        <ng-container *ngIf="extraItem.hasAdditionalInfo$ | async">
                                                          <div a11y_Button class="additional-info"
                                                            (click)="openAddidtionInformationDialog(extraItem);$event.stopPropagation()">
                                                            <span>i</span>
                                                          </div>
                                                        </ng-container>
                                                        <div class="check-wrap" [class.active]="extraItem.count > 0">
                                                          <div class="check">
                                                            <div *ngIf="extraItem.count > 0"
                                                              class="inline-icon item-check-svg"
                                                              inlineSVG="shop-icons.svg#ya-done">
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </ng-template>
                                              <ng-template #extraItemWithoutImage>
                                                <div class="article-without-image">
                                                  <div a11y_Button class="item"
                                                    (click)="onItemClick(extragroup, extraItem); $event.stopPropagation()"
                                                    [ngClass]="extraItem.count > 0 ? 'selected' : ''"
                                                    [class.not-available]="!extraItem.isAvailable">
                                                    <div class="not-available-overlay" *ngIf="!extraItem.isAvailable">
                                                      <div class="not-available-header">[<span
                                                          langkey="phProductDetail_CurrentlyNotAvailable"></span>]
                                                      </div>
                                                    </div>
                                                    <div class="article-item">
                                                      <div class="article-texte">
                                                        <div class="extra-content">
                                                          <div class="article-label">
                                                            <div class="text">{{extraItem.label}}</div>
                                                          </div>
                                                          <!--Extra: Base price & Deposit-->
                                                          <ng-container
                                                            *ngIf="(extraItem.displayExtraBasePrice$|async) ||extraItem.deposit>0">
                                                            <div class="product-content__info">
                                                              <ng-container *ngIf="extraItem.deposit>0">
                                                                <span
                                                                  class="extra-info">{{extraitemDepositInfo(extraItem)}}</span>
                                                              </ng-container>
                                                              <ng-container
                                                                *ngIf="(extraItem.displayExtraBasePrice$|async)">
                                                                <ng-container *ngIf="showBasePrice(extraItem)">
                                                                  <div class="ecommerce-info">
                                                                    <div class="base-content-info">
                                                                      <span
                                                                        class="extra-info">{{getExtraItemBaseUnit(extraItem)}}</span>
                                                                    </div>
                                                                  </div>
                                                                </ng-container>
                                                              </ng-container>
                                                            </div>
                                                          </ng-container>
                                                        </div>
                                                        <div class="extra-amount">
                                                          <div class="price">{{priceFormatter(extraItem.price)}}
                                                          </div>
                                                          <ng-container
                                                            *ngIf="extragroup.max > 1 && extraItem.max > 1 && extraItem.count > 0">
                                                            <div class="amountChanger">
                                                              <div class="minus"
                                                                (click)="decrementExtra(extragroup, extraItem); $event.stopPropagation()">
                                                                <div class="inline-icon"
                                                                  inlineSVG="shop-icons.svg#ya-hypersoft-minus-voll">
                                                                </div>
                                                              </div>
                                                              <div class="amount">{{extraItem.count}}</div>
                                                              <div class="plus"
                                                                (click)="incrementExtra(extragroup, extraItem); $event.stopPropagation()">
                                                                <div class="inline-icon"
                                                                  inlineSVG="shop-icons.svg#ya-hypersoft-plus-voll">
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </ng-container>
                                                        </div>
                                                      </div>
                                                      <div class="article-icons">
                                                        <ng-container *ngIf="extraItem.hasAdditionalInfo$ | async">
                                                          <div a11y_Button class="additional-info"
                                                            (click)="openAddidtionInformationDialog(extraItem);$event.stopPropagation()">
                                                            <span>i</span>
                                                          </div>
                                                        </ng-container>
                                                        <div class="check-wrap" [class.active]="extraItem.count > 0">
                                                          <div class="check">
                                                            <div *ngIf="extraItem.count > 0"
                                                              class="inline-icon item-check-svg"
                                                              inlineSVG="shop-icons.svg#ya-done">
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </ng-template>
                                            </div>
                                          </div>
                                        </div>
                                      </ng-template>
                                      <ng-template #extraWithSubExtras>
                                        <mat-expansion-panel a11y_Button class="subchoice"
                                          (opened)="extraItem.expanded=true" (closed)="extraItem.expanded=false"
                                          hideToggle="true" [disabled]="!extraItem.isAvailable">
                                          <mat-expansion-panel-header collapsedHeight="*" expandedHeight="*">
                                            <mat-panel-title>
                                              <div class="extraitem-content"
                                                [class.not-available]="!extraItem.isAvailable">
                                                <div class="not-available-overlay" *ngIf="!extraItem.isAvailable">
                                                  <div class="not-available-header">[<span
                                                      langkey="phProductDetail_CurrentlyNotAvailable"></span>]
                                                  </div>
                                                </div>
                                                <div class="item subitem_header"
                                                  [ngClass]="extraItem.count > 0 ? 'selected' : ''">
                                                  <div class="info" [class.active]="extraItem.count > 0">
                                                    <ng-template
                                                      *ngIf="extraItem.hasImage; then subExtraItemWithImage else subExtraItemWithoutImage"></ng-template>
                                                    <ng-template #subExtraItemWithImage>
                                                      <div class="article-image-container">
                                                        <img class="ya_image extraitem-image"
                                                          [src]="extraItem.imageUrl" />
                                                      </div>
                                                      <div class="article-with-sub-infos">
                                                        <div class="article-label-with-sub">
                                                          <div class="article-with-sub-label">
                                                            <div class="text">{{extraItem.label}}</div>
                                                            <ng-container
                                                              *ngIf="extragroup.max > 1 && extraItem.max > 1 && extraItem.count > 0">
                                                              <div class="amount">{{extraItem.count}}</div>
                                                            </ng-container>
                                                          </div>
                                                          <div class="extra-content">
                                                            <!--Extra: Base price & Deposit-->
                                                            <ng-container
                                                              *ngIf="(extraItem.displayExtraBasePrice$|async) ||extraItem.deposit>0">
                                                              <div class="product-content__info">
                                                                <ng-container *ngIf="extraItem.deposit>0">
                                                                  <span
                                                                    class="extra-info">{{extraitemDepositInfo(extraItem)}}</span>
                                                                </ng-container>
                                                                <ng-container
                                                                  *ngIf="(extraItem.displayExtraBasePrice$|async)">
                                                                  <ng-container *ngIf="showBasePrice(extraItem)">
                                                                    <div class="ecommerce-info">
                                                                      <div class="base-content-info">
                                                                        <span
                                                                          class="extra-info">{{getExtraItemBaseUnit(extraItem)}}</span>
                                                                      </div>
                                                                    </div>
                                                                  </ng-container>
                                                                </ng-container>
                                                              </div>
                                                            </ng-container>
                                                          </div>
                                                          <div class="price" *ngIf="extraItem.price > 0">
                                                            {{priceFormatter(extraItem.price)}}
                                                          </div>
                                                        </div>
                                                        <div class="article-with-sub-icons">
                                                          <div class="additional-content"
                                                            *ngIf="extraItem.hasAdditionalInfo$ | async">
                                                            <div a11y_Button class="additional-info"
                                                              (click)="openAddidtionInformationDialog(extraItem);$event.stopPropagation()">
                                                              <span>i</span>
                                                            </div>
                                                          </div>
                                                          <div [class.expanded]="extraItem.expanded"
                                                            class="inline-icon subItemExpand-icon"
                                                            inlineSVG="shop-icons.svg#ya-expand_more">
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </ng-template>
                                                    <ng-template #subExtraItemWithoutImage>
                                                      <div class="article-sub-infos-noimage">
                                                        <div class="article-label-with-sub">
                                                          <div class="article-with-sub-label">
                                                            <div class="text">{{extraItem.label}}</div>
                                                            <ng-container
                                                              *ngIf="extragroup.max > 1 && extraItem.max > 1 && extraItem.count > 0">
                                                              <div class="amount">{{extraItem.count}}</div>
                                                            </ng-container>
                                                          </div>
                                                          <div class="extra-content">
                                                            <!--Extra: Base price & Deposit-->
                                                            <ng-container
                                                              *ngIf="(extraItem.displayExtraBasePrice$|async) ||extraItem.deposit>0">
                                                              <div class="product-content__info">
                                                                <ng-container *ngIf="extraItem.deposit>0">
                                                                  <span
                                                                    class="extra-info">{{extraitemDepositInfo(extraItem)}}</span>
                                                                </ng-container>
                                                                <ng-container
                                                                  *ngIf="(extraItem.displayExtraBasePrice$|async)">
                                                                  <ng-container *ngIf="showBasePrice(extraItem)">
                                                                    <div class="ecommerce-info">
                                                                      <div class="base-content-info">
                                                                        <span
                                                                          class="extra-info">{{getExtraItemBaseUnit(extraItem)}}</span>
                                                                      </div>
                                                                    </div>
                                                                  </ng-container>
                                                                </ng-container>
                                                              </div>
                                                            </ng-container>
                                                          </div>
                                                          <div class="price" *ngIf="extraItem.price > 0">
                                                            {{priceFormatter(extraItem.price)}}</div>
                                                        </div>
                                                        <div class="article-with-sub-icons">
                                                          <div class="additional-content"
                                                            *ngIf="extraItem.hasAdditionalInfo$ | async">
                                                            <div a11y_Button class="additional-info"
                                                              (click)="openAddidtionInformationDialog(extraItem);$event.stopPropagation()">
                                                              <span>i</span>
                                                            </div>
                                                          </div>
                                                          <div [class.expanded]="extraItem.expanded"
                                                            class="inline-icon subItemExpand-icon"
                                                            inlineSVG="shop-icons.svg#ya-expand_more">
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </ng-template>
                                                  </div>
                                                </div>
                                              </div>
                                            </mat-panel-title>
                                          </mat-expansion-panel-header>
                                          <div class="subItems">
                                            <ng-container *ngFor="let subextraItem of extraItem.subExtras">
                                              <div class="extraitem-content">
                                                <div a11y_Button class="item subitem"
                                                  (click)="onItemClick(extragroup, extraItem, subextraItem); $event.stopPropagation()"
                                                  [ngClass]="subextraItem.count > 0 ? 'selected' : ''"
                                                  [class.not-available]="!subextraItem.isAvailable">
                                                  <div class="not-available-overlay" *ngIf="!subextraItem.isAvailable">
                                                    <div class="not-available-header">[<span
                                                        langkey="phProductDetail_CurrentlyNotAvailable"></span>]
                                                    </div>
                                                  </div>
                                                  <div class="info" [class.active]="subextraItem.count > 0">
                                                    <ng-template
                                                      *ngIf="subextraItem.hasImage; then subExtraImageView else subExtraTextOnlyView"></ng-template>
                                                    <ng-template #subExtraImageView>
                                                      <img class="ya_image subitem-image"
                                                        [src]="subextraItem.imageUrl" />
                                                      <div class="article-sub-infos">
                                                        <div class="article-sub-label">
                                                          <div class="text">{{subextraItem.label}}</div>
                                                          <div class="extra-content">
                                                            <!--Subextra: Base price & Deposit-->
                                                            <ng-container
                                                              *ngIf="(subextraItem.displayExtraBasePrice$|async) ||subextraItem.deposit>0">
                                                              <div class="product-content__info space-custom">
                                                                <ng-container *ngIf="subextraItem.deposit>0">
                                                                  <span
                                                                    class="extra-info">{{extraitemDepositInfo(subextraItem)}}</span>
                                                                </ng-container>
                                                                <ng-container
                                                                  *ngIf="(subextraItem.displayExtraBasePrice$|async)">
                                                                  <ng-container *ngIf="showBasePrice(subextraItem)">
                                                                    <div class="ecommerce-info">
                                                                      <div class="base-content-info">
                                                                        <span
                                                                          class="extra-info">{{getExtraItemBaseUnit(subextraItem)}}</span>
                                                                      </div>
                                                                    </div>
                                                                  </ng-container>
                                                                </ng-container>
                                                              </div>
                                                            </ng-container>
                                                          </div>
                                                          <div class="article-sub-amount">
                                                            <div class="price">
                                                              {{priceFormatter(subextraItem.price)}}
                                                            </div>
                                                            <ng-container
                                                              *ngIf="extragroup.max > 1 && subextraItem.max > 1 && subextraItem.count > 0">
                                                              <div class="amountChanger">
                                                                <div class="minus"
                                                                  (click)="decrementExtra(extragroup, extraItem, subextraItem); $event.stopPropagation()">
                                                                  <div class="inline-icon"
                                                                    inlineSVG="shop-icons.svg#ya-hypersoft-minus-voll">
                                                                  </div>
                                                                </div>
                                                                <div class="amount">{{subextraItem.count}}</div>
                                                                <div class="plus"
                                                                  (click)="incrementExtra(extragroup, extraItem, subextraItem); $event.stopPropagation()">
                                                                  <div class="inline-icon"
                                                                    inlineSVG="shop-icons.svg#ya-hypersoft-plus-voll">
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </ng-container>
                                                          </div>
                                                        </div>
                                                        <div class="article-sub-icons">
                                                          <div class="additional-content"
                                                            *ngIf="subextraItem.hasAdditionalInfo$ | async">
                                                            <div a11y_Button class="additional-info"
                                                              (click)="openAddidtionInformationDialog(subextraItem);$event.stopPropagation()">
                                                              <span>i</span>
                                                            </div>
                                                          </div>
                                                          <div class="check-wrap"
                                                            [class.active]="subextraItem.count > 0">
                                                            <div class="check">
                                                              <div *ngIf="subextraItem.count > 0"
                                                                class="inline-icon item-check-svg"
                                                                inlineSVG="shop-icons.svg#ya-done">
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </ng-template>
                                                    <ng-template #subExtraTextOnlyView>
                                                      <div class="article-sub-infos-noimage">
                                                        <div class="article-sub-label">
                                                          <div class="text">{{subextraItem.label}}</div>
                                                          <div class="extra-content">
                                                            <!--Subextra: Base price & Deposit-->
                                                            <ng-container
                                                              *ngIf="(subextraItem.displayExtraBasePrice$|async) ||subextraItem.deposit>0">
                                                              <div class="product-content__info">
                                                                <ng-container *ngIf="subextraItem.deposit>0">
                                                                  <span
                                                                    class="extra-info">{{extraitemDepositInfo(subextraItem)}}</span>
                                                                </ng-container>
                                                                <ng-container
                                                                  *ngIf="(subextraItem.displayExtraBasePrice$|async)">
                                                                  <ng-container *ngIf="showBasePrice(subextraItem)">
                                                                    <div class="ecommerce-info">
                                                                      <div class="base-content-info">
                                                                        <span
                                                                          class="extra-info">{{getExtraItemBaseUnit(subextraItem)}}</span>
                                                                      </div>
                                                                    </div>
                                                                  </ng-container>
                                                                </ng-container>
                                                              </div>
                                                            </ng-container>
                                                          </div>
                                                          <div class="article-sub-amount">
                                                            <div class="price">{{priceFormatter(subextraItem.price)}}
                                                            </div>
                                                            <ng-container
                                                              *ngIf="extragroup.max > 1 && subextraItem.max > 1 && subextraItem.count > 0">
                                                              <div class="amountChanger">
                                                                <div class="minus"
                                                                  (click)="decrementExtra(extragroup, extraItem, subextraItem); $event.stopPropagation()">
                                                                  <div class="inline-icon"
                                                                    inlineSVG="shop-icons.svg#ya-hypersoft-minus-voll">
                                                                  </div>
                                                                </div>
                                                                <div class="amount">{{subextraItem.count}}</div>
                                                                <div class="plus"
                                                                  (click)="incrementExtra(extragroup, extraItem, subextraItem); $event.stopPropagation()">
                                                                  <div class="inline-icon"
                                                                    inlineSVG="shop-icons.svg#ya-hypersoft-plus-voll">
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </ng-container>
                                                          </div>
                                                        </div>
                                                        <div class="article-sub-icons">
                                                          <div class="additional-content"
                                                            *ngIf="subextraItem.hasAdditionalInfo$ | async">
                                                            <div a11y_Button class="additional-info"
                                                              (click)="openAddidtionInformationDialog(subextraItem); $event.stopPropagation()">
                                                              <span>i</span>
                                                            </div>
                                                          </div>
                                                          <div class="check-wrap"
                                                            [class.active]="subextraItem.count > 0">
                                                            <div class="check">
                                                              <div *ngIf="subextraItem.count > 0"
                                                                class="inline-icon item-check-svg"
                                                                inlineSVG="shop-icons.svg#ya-done">
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </ng-template>
                                                  </div>
                                                </div>
                                              </div>
                                            </ng-container>
                                          </div>
                                        </mat-expansion-panel>
                                      </ng-template>
                                    </ng-template>
                                    <!-- normalView ende-->
                                  </ng-container>
                                </ng-container>
                              </div>
                              <ng-container
                                *ngIf="extragroup.showUpToNItems < extragroup.items.length || extragroup.showUpToNItems === extragroup.items.length">
                                <div a11y_Button class="expand"
                                  *ngIf="extragroup.showUpToNItems < extragroup.items.length"
                                  (click)="expandExtra(extragroup)">
                                  <div class="expand-text"><span langkey="phProductDetail_ShowAdditionalOption"></span>
                                  </div>
                                  <div class="expand-icon">
                                    <div class="inline-icon expand-svg" inlineSVG="shop-icons.svg#ya-expand_more"></div>
                                  </div>
                                </div>
                                <div class="collapse"
                                  *ngIf="extragroup.showUpToNItems === extragroup.items.length && extragroup.items.length > 5"
                                  (click)="expandExtra(extragroup)">
                                  <div class="collapse-icon">
                                    <div class="inline-icon expand-svg" inlineSVG="expand_more.svg"></div>
                                  </div>
                                  <div class="collapse-text"><span langkey="phProductDetail_ShowLessOption"></span>
                                  </div>
                                </div>
                              </ng-container>
                            </div>
                          </ng-container>
                          <!-- Product  comment -->
                          <ng-container *ngIf="use_item_annotation">
                            <div class="product-comment">
                              <div class="title ya-header-2"><span>{{annotationTitle}}</span></div>
                              <textarea a11y_Input [(ngModel)]="itemAnnotationText"
                                [placeholder]="annotationPlaceholder" class="ya-caption comment-textarea show-comment"
                                minlength="1" maxlength="200" id="commentTextarea-{{ productDetailViewModel.id}}"
                                (focus)="setWebView()"
                                (blur)="onBlur($event.currentTarget.value); setWebView()"></textarea>
                            </div>
                          </ng-container>
                        </div>
                        <ng-container *ngIf="isChargeVoucher()">
                          <div class="variablePriceContainer">
                            <div class="title"><span langkey="phProductDetail_EnterYourDesiredAmount"></span>:
                            </div>
                            <div class="input-amount">
                              <div class="ya-input-container">
                                <input a11y_Input class="ya-input-text" (keyup)="onInputVariablePriceChange()"
                                  onpaste="return false;" oncopy="return false" oncut="return false"
                                  ondrag="return false" ondrop="return false" (keypress)="isNumberKey($event)"
                                  (blur)="onInputVariablePriceBlur(); setWebView()"
                                  [(ngModel)]="variablePriceInputValue">
                              </div>
                              <span> {{currencySymbol}}</span>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                    <ng-container *ngIf="!isOnline">
                      <div class="product-date-wrapper">
                        <mat-divider></mat-divider>
                        <div>
                          <span langkey="phProductDetail_Date_Caption"></span>
                          {{productDetailViewModel.lastSynceData}}
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                  <!-- Labelling Tab -->
                  <ng-container *ngSwitchCase="GroupTabs(productHeaderGroup.id)">
                    <ng-container *ngIf="VerifyTabContent(productDetailViewModel)">
                      <div class="col2">
                        <!--Additives-->
                        <ng-container *ngIf="headerGroupAdditives && headerGroupAdditives.content">
                          <div class="item-list">
                            <div class="item-list__item item-list__item--header ya-header-2">
                              <span langkey="phProductDetail_Additives"></span><span
                                class="item-list__footnotemark">*</span>
                            </div>
                            <div class="item-list-treat-p-as-element" innerHtml="{{headerGroupAdditives.content}}">
                            </div>
                          </div>
                        </ng-container>
                        <!--Allergenes-->
                        <ng-container *ngIf="headerGroupAllergies && headerGroupAllergies.content">
                          <div class="item-list">
                            <div class="item-list__item item-list__item--header ya-header-2">
                              <span langkey="phProductDetail_Allergy"></span><span
                                class="item-list__footnotemark">*</span>
                            </div>
                            <div class="item-list-treat-p-as-element" innerHtml="{{headerGroupAllergies.content}}">
                            </div>
                          </div>
                        </ng-container>
                        <!-- CO2 Tab -->
                        <ng-container *ngIf="headerGroupCO2 && headerGroupCO2.content">
                          <div class="item-list">
                            <div class="item-list__item item-list__item--header ya-header-2">
                              <span>CO<sub>2</sub></span><span class="item-list__footnotemark">*</span>
                            </div>
                            <div class="item-list__item">
                              <ng-container *ngIf="productHeaderGroup.content">
                                <span>{{productHeaderGroup.content}}g CO<sub>2</sub></span>
                              </ng-container>
                            </div>
                          </div>
                        </ng-container>
                        <!--Ingredients-->
                        <ng-container
                          *ngIf="productDetailViewModel.use_eCommerce && productDetailViewModel.hasItemContent">
                          <div class="item-list">
                            <div class="item-list__item item-list__item--header ya-header-2">
                              <span langkey="phProductDetail_Content"></span><span
                                class="item-list__footnotemark">*</span>
                            </div>
                            <div class="item-list-treat-p-as-element eCommerce-info__label"
                              innerHtml="{{productDetailViewModel.item_content}}"></div>
                          </div>
                        </ng-container>
                        <!--Provider-->
                        <ng-container
                          *ngIf="productDetailViewModel.use_eCommerce && (productDetailViewModel.hasItemProviderName || productDetailViewModel.hasItemProviderAddr)">
                          <div class="item-list">
                            <div class="item-list__item item-list__item--header ya-header-2">
                              <span langkey="phProductDetail_Distributor"></span><span
                                class="item-list__footnotemark">*</span>
                            </div>
                            <ng-container *ngIf="productDetailViewModel.hasItemProviderName">
                              <div class="item-list-treat-p-as-element eCommerce-info__label"
                                innerHtml="{{productDetailViewModel.item_provider_name}}">
                              </div>
                            </ng-container>
                            <ng-container *ngIf="productDetailViewModel.hasItemProviderAddr">
                              <div class="item-list-treat-p-as-element eCommerce-info__label"
                                innerHtml="{{productDetailViewModel.item_provider_addr}}">
                              </div>
                            </ng-container>
                          </div>
                        </ng-container>
                        <div class="item-list">
                          <div class="item-list__footnote">
                            * <span langkey="phProductDetail_InfosNotForCustomizedOrders_TEXT"></span>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                  <!-- Nutrition Tab -->
                  <ng-container *ngSwitchCase="productHeaderGroup.id === 6">
                    <ng-container *ngIf="productDetailViewModel.nutritions
                      && productDetailViewModel.nutritions.nutritionItemViewModels
                      && productDetailViewModel.nutritions.nutritionItemViewModels.length>0">
                      <div class="col2">
                        <div class="product-nutrition-container">
                          <div class="item-list">
                            <div class="item-list__item item-list__item--header ya-header-2">
                              <div class="nutrition-item">
                                <div class="nutrition-item-title">
                                  <span langkey=phProductDetail_AdditionalInformations></span>
                                </div>
                                <div class="nutrition-item-value">
                                  {{productDetailViewModel.nutritions.header}}<span
                                    class="item-list__footnotemark">*</span>
                                </div>
                              </div>
                            </div>
                            <ng-container
                              *ngFor="let nutritionItem of productDetailViewModel.nutritions.nutritionItemViewModels">
                              <div class="item-list__item">
                                <div class="nutrition-item">
                                  <div class="nutrition-item-title">
                                    {{nutritionItem.title}}
                                  </div>
                                  <div class="nutrition-item-value">
                                    {{nutritionItem.value}}
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                            <div class="item-list__footnote">
                              * <span langkey="phProductDetail_InfosNotForCustomizedOrders_TEXT"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </div>
            </mat-tab>
          </ng-container>
        </ng-container>
      </mat-tab-group>
      <div class="buying" *ngIf="showBuying && currentProductSettingIndex == 0">
          <ng-container *ngIf="serviceId !== WebShopMode.Webvoucher">
            <div class="amountselector webshop-button webshop-button--hollow">
              <ng-container *ngIf="!isAmountLocked; then decreaseEnabled else decreaseDisabled"></ng-container>
              <ng-template #decreaseEnabled>
                <div a11y_Button class="amountchanger" (click)="decreaseAmount()">
                  <div class="inline-icon decrease" inlineSVG="shop-icons.svg#ya-hypersoft-minus-voll">
                  </div>
                </div>
              </ng-template>
              <ng-template #decreaseDisabled>
                <div a11y_Button class="amountchanger amountchanger--disabled">
                  <div class="inline-icon decrease disabled" inlineSVG="shop-icons.svg#ya-hypersoft-minus-voll"></div>
                </div>
              </ng-template>
              <div class="amount">
                <input a11y_SpinButton class="amount-count-input" type="text" [(ngModel)]="buyAmount" maxlength="2"
                  [readonly]="isAmountLocked" numericInput [placeholder]="buyAmount" onpaste="return false;"
                  oncopy="return false" pattern="[0-9]*" inputmode="numeric" oncut="return false" ondrag="return false"
                  ondrop="return false" (blur)="onBlurAmount(); setWebView()" (focus)="onFocusAmount($event)">
              </div>
              <ng-container *ngIf="!isAmountLocked; then addCountEnabled else addCountDisabled"></ng-container>
              <ng-template #addCountEnabled>
                <div a11y_Button class="amountchanger" (click)="increaseAmount()">
                  <div class="inline-icon increase" inlineSVG="shop-icons.svg#ya-hypersoft-plus-voll">
                  </div>
                </div>
              </ng-template>
              <ng-template #addCountDisabled>
                <div a11y_Button class="amountchanger amountchanger--disabled">
                  <div class="inline-icon increase disabled" inlineSVG="shop-icons.svg#ya-hypersoft-plus-voll"></div>
                </div>
              </ng-template>
            </div>
          </ng-container>
        <div class="price-button-container">
          <ng-container *ngIf="serviceId == WebShopMode.Viewing; then viewOnlyMode else canPurchaseMode">
          </ng-container>
          <ng-template #viewOnlyMode>
            <div a11y_Button class="webshop-button webshop-button--disabled addToBasketBtn"
              (click)="openAnnounceDialog()">
              <div class="price">{{priceFormatter(getTotalPrice())}}</div>
            </div>
          </ng-template>
          <ng-template #canPurchaseMode>
            <ng-container *ngIf="isCouponAddLocked; then couponLockedAddToCartButton else purchasableAddToCartButton">
            </ng-container>
            <ng-template #couponLockedAddToCartButton>
              <div a11y_Button class="webshop-button webshop-button--disabled addToBasketBtn"
                (click)="openInCartDialog()">
                <div class="price">{{displayItemPrice()}}</div>
                <div class="inline-icon price-img" inlineSVG="shop-icons.svg#ya-hypersoft-warenkorp"></div>
              </div>
            </ng-template>
            <ng-template #purchasableAddToCartButton>
              <ng-container *ngIf="canAddToCart(); then enabledAddToCartButton else disabledAddToCartButton">
              </ng-container>
              <ng-template #enabledAddToCartButton>
                <div a11y_Button class="webshop-button addToBasketBtn"
                  (click)="verifyAndAddproductToBasket(buyAmount, $event)">
                  <div class="price">{{displayItemPrice()}}</div>
                  <div class="inline-icon price-img" inlineSVG="shop-icons.svg#ya-hypersoft-warenkorp"></div>
                </div>
              </ng-template>
              <ng-template #disabledAddToCartButton>
                <div a11y_Button class="webshop-button webshop-button--disabled addToBasketBtn">
                  <div class="price">{{displayItemPrice()}}</div>
                  <div class="inline-icon price-img" inlineSVG="shop-icons.svg#ya-hypersoft-warenkorp"></div>
                </div>
              </ng-template>
            </ng-template>
          </ng-template>
          <ng-container *ngIf="isSmallView">
            <ng-container *ngIf="hasDepositPrice()">
              <div class="depositview">
                <span>{{depositInfo()}}</span>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </ng-template>
    <ng-template #emptyTemplate>
      <ya-emptypage></ya-emptypage>
    </ng-template>
  </div>
</div>